import { ChangeEvent } from "react";
import "./style.scss";

type CheckBoxProps = {
  onChange: (checked: boolean) => void;
  checked: boolean
};

export const CheckBox: React.FC<CheckBoxProps> = (props) => {
  const { onChange, checked } = props;

  const change = (evt: ChangeEvent<HTMLInputElement>) => {
    onChange(evt.target.checked);
  };

  return (
    <input
      type="checkbox"
      className="checkBox"
      checked={checked}
      onChange={change}
    />
  );
};
